import axios from '@/apis/axios';

class CorporateUser 
{
    static async getCorporateShareholder(id)
    {
        const response = await axios.get(`api/company/corporate-shareholder/${id}`);

        return response.data.data;
    }
}
export default CorporateUser;